// extracted by mini-css-extract-plugin
export default {"container":"title-nav_container__gf8Bm"};